export const EtherSymbol="Ξ";